/**
 * @generated SignedSource<<3933bc99277dd3082f972f5de4a18d40>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges$data = ReadonlyArray<{
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges">;
  readonly " $fragmentType": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges";
}>;
export type emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges$key = ReadonlyArray<{
  readonly " $data"?: emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges$data;
  readonly " $fragmentSpreads": FragmentRefs<"emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "emptyState_softwareReleasesVersionRelatedWork_RelatedWorkEmptyState_relatedWorkEdges",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "async_softwareReleasesAddRelatedWorkToVersion_AddRelatedWorkPopup_relatedWorkEdges"
    }
  ],
  "type": "JiraVersionRelatedWorkV2Edge"
};

(node as any).hash = "93018a8cf1d1d8516c9bb5d6c022ae78";

export default node;
